const STATS = [
  { value: '50,000+', label: 'Active Consumers' },
  { value: '100%', label: 'ANZ Coverage' },
  { value: '3', label: 'Global Offices' },
  { value: '1000+', label: 'Products Launched' },
];

export const Stats = () => (
  <section className="py-16 bg-gradient-to-r from-[#1e3a8a] via-[#004aad] to-[#1e3a8a]">
    <div className="container mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {STATS.map((s) => (
          <div key={s.label} className="text-center glow-border rounded-2xl p-6 bg-white/10 backdrop-blur-sm card-lift">
            <div className="text-4xl md:text-5xl font-bold text-white mb-2">{s.value}</div>
            <div className="text-blue-100 font-medium">{s.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
